module.exports = __webpack_public_path__ + "img/banner-3.5d8547e9.png";